import { InMemoryTranslator } from "./InMemoryTranslator";

export class Translator {
  public static t(text: string) {
    return this.translator.t(text);
  }

  private static translator = new InMemoryTranslator();
}
